import * as module from "./module";

module.test( module.message );
